import React, { useEffect, useMemo, useState } from 'react';

import { Box, Column, GridContainer, Row } from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { CarouselData } from '../domain/CarouselData';
import { Combination } from '../domain/Combination';
import { SlideArray } from '../domain/SlideArray';

import { Gallery, GoToSlide } from './Gallery';

export interface CarouselProps {
  tenant: string;
  carouselData: CarouselData;
  selectedCombination: Combination;
  zoomContainerId?: string;
  canonicalDomain: string;
  mpvId: string;
  productKey: string;
}

export const Carousel: React.FC<CarouselProps> = (props) => {
  const { t } = useLocalizations();

  const [currentSlideIndex, setCurrentSlideIndex] = useState<GoToSlide | undefined>(undefined);

  useEffect(() => {
    const brandkitImage = props.carouselData.getBrandkitImageIndex(props.selectedCombination);
    if (brandkitImage !== null) {
      updateGoToSlide(brandkitImage);
      return;
    }
    const documentIndex = props.carouselData.getDocumentImageIndex(props.selectedCombination);
    if (documentIndex !== null) {
      updateGoToSlide(documentIndex);
      return;
    }
    if (props.selectedCombination.isInitial) {
      return;
    }

    const referentialImageIndex = props.carouselData.getReferentialImageIndex(
      props.selectedCombination
    );

    if (referentialImageIndex !== null) {
      updateGoToSlide(referentialImageIndex);
    }

    function updateGoToSlide(index: number) {
      setCurrentSlideIndex({ slideNumber: index + 1 });
    }
  }, [props.selectedCombination, props.carouselData]);

  const scenesForCombination = useMemo<SlideArray>(
    () => props.carouselData.getSlidesByCombination(props.selectedCombination),
    [props.selectedCombination, props.carouselData]
  );

  return (
    <Box aria-label={t('carousel-container-label')} role="group">
      <GridContainer>
        <Row paddingBottom={4}>
          <Column span={12}>
            <Gallery
              key={`${scenesForCombination.all.map((m) => m.galleryId).join('-')}`}
              mediaArray={scenesForCombination}
              goToSlide={currentSlideIndex}
              zoomContainerId={props.zoomContainerId}
              tenant={props.tenant}
              canonicalDomain={props.canonicalDomain}
              mpvId={props.mpvId}
              productKey={props.productKey}
            />
          </Column>
        </Row>
      </GridContainer>
    </Box>
  );
};
